
export {} from '@clayui/badge';
import __x__ from '@clayui/badge';export default __x__;